var __TEMP__ = require('./_baseIsEqual.js');var baseIsEqual = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./get.js');var get = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./hasIn.js');var hasIn = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_isKey.js');var isKey = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_isStrictComparable.js');var isStrictComparable = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_matchesStrictComparable.js');var matchesStrictComparable = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_toKey.js');var toKey = __REQUIRE_DEFAULT__(__TEMP__);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseMatchesProperty;
